const SUPER_ADMIN_ROLE_NAME = 'Super Admin';

export const isSuperAdminIpAdmin = (accountData) => {
  if (!accountData || typeof accountData !== 'object') {
    return false;
  }

  return accountData?.role?.name === SUPER_ADMIN_ROLE_NAME && accountData?.ip_admin === true;
};

export const canManageTelegramNotifications = (accountData) => {
  return isSuperAdminIpAdmin(accountData);
};
